(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wholesale-application-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wholesale-inline-cta]').forEach(function (cta) {
    var article = cta.closest('main') ? cta.closest('main').querySelector('article') : null;
    if (!article) return;
    var applyHeading = Array.from(article.querySelectorAll('h2')).find(function (heading) {
      return heading.textContent.trim() === 'How to Apply';
    });
    if (!applyHeading) return;
    var nextElement = applyHeading.nextElementSibling;
    while (nextElement && nextElement.tagName !== 'H2') {
      var elementToRemove = nextElement;
      nextElement = nextElement.nextElementSibling;
      elementToRemove.remove();
    }
    applyHeading.insertAdjacentElement('afterend', cta);
  });

  document.querySelectorAll('[data-wholesale-application]').forEach(function (root) {
    var form = root.querySelector('form');
    var success = root.querySelector('[data-wholesale-success]');
    var storageKey = 'ehaWholesaleApplicationDraftV2';
    if (success) {
      try { window.sessionStorage.removeItem(storageKey); } catch (error) { void error; }
      success.focus();
      return;
    }
    if (!form) return;
    var submitButton = form.querySelector('[data-wholesale-submit]');

    function syncAddressPanel(toggle) {
      var panel = form.querySelector('[data-address-panel="' + toggle.dataset.addressToggle + '"]');
      if (!panel) return;
      var sameAddress = toggle.checked;
      panel.hidden = sameAddress;
      panel.querySelectorAll('input, textarea').forEach(function (field) {
        field.disabled = sameAddress;
        if (field.hasAttribute('data-required-when-visible')) field.required = !sameAddress;
      });
    }

    form.querySelectorAll('[data-address-toggle]').forEach(function (toggle) {
      toggle.addEventListener('change', function () { syncAddressPanel(toggle); });
      syncAddressPanel(toggle);
    });

    function saveDraft() {
      var draft = Array.from(form.elements).filter(function (field) {
        return field.name && field.name !== 'contact[body]' && field.name !== 'website_confirm';
      }).map(function (field) {
        var value = field.type === 'file' ? (field.files && field.files[0] ? field.files[0].name : '') : field.value;
        return {
          name: field.name,
          type: field.type,
          value: value,
          checked: Boolean(field.checked)
        };
      });
      try { window.sessionStorage.setItem(storageKey, JSON.stringify(draft)); } catch (error) { void error; }
    }

    function restoreDraft() {
      var draft;
      try { draft = JSON.parse(window.sessionStorage.getItem(storageKey) || '[]'); } catch (error) { draft = []; }
      draft.forEach(function (saved) {
        var fields = Array.from(form.elements).filter(function (field) {
          return field.name === saved.name && field.type === saved.type;
        });
        fields.forEach(function (field) {
          if (field.type === 'file') return;
          if (field.type === 'checkbox' || field.type === 'radio') {
            if (field.value === saved.value) field.checked = saved.checked;
          } else {
            field.value = saved.value;
          }
        });
      });
      form.querySelectorAll('[data-address-toggle]').forEach(syncAddressPanel);
    }

    form.addEventListener('change', saveDraft);
    form.addEventListener('input', function (event) {
      if (event.target.matches('input, textarea')) saveDraft();
    });

    form.addEventListener('submit', function (event) {
      if (form.querySelector('[data-wholesale-honeypot]').value) {
        event.preventDefault();
        return;
      }

      var grouped = new Map();
      form.querySelectorAll('[data-summary-label]').forEach(function (field) {
        if (field.disabled) return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        var value = String(field.value || '').trim();
        if (!value) return;
        var label = field.dataset.summaryLabel;
        if (!grouped.has(label)) grouped.set(label, []);
        grouped.get(label).push(value);
      });

      var lines = [
        'eHobbyAsia Wholesale Application',
        'Submitted: ' + new Date().toISOString(),
        'Page: ' + window.location.href.split('?')[0],
        ''
      ];
      grouped.forEach(function (values, label) {
        lines.push(label + ': ' + Array.from(new Set(values)).join(', '));
      });
      var fileInput = form.querySelector('input[type="file"][name="contact[business_registration_certificate]"]');
      if (fileInput && fileInput.files && fileInput.files[0]) {
        lines.push('Uploaded file: ' + fileInput.files[0].name);
      }
      form.querySelector('[data-wholesale-summary]').value = lines.join('\n');
      if (submitButton) submitButton.disabled = true;
    });

    restoreDraft();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-info"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-wishlist-page]');
  if (!root || typeof window.jQuery === 'undefined') return;

  const $ = window.jQuery;
  const results = root.querySelector('#wishlisthtml');
  const share = root.querySelector('[data-wishlist-share]');
  const customerId = root.dataset.customerId;
  const customerTags = root.dataset.customerTags;

  const text = {
    emptyTitle: root.dataset.emptyTitle,
    emptyBody: root.dataset.emptyBody,
    browseNew: root.dataset.browseNew,
    shopSale: root.dataset.shopSale,
    addToCart: root.dataset.addToCart,
    remove: root.dataset.remove,
    loading: root.dataset.loading,
    loadError: root.dataset.loadError
  };

  const escapeHtml = (value) => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const getWishlistId = () => {
    const match = document.cookie
      .split(';')
      .map((part) => part.trim())
      .find((part) => part.startsWith('wishlist_id='));
    return match ? decodeURIComponent(match.slice('wishlist_id='.length)) : '';
  };

  const emptyState = (isError = false) => `
    <div class="wishlist-empty">
      <div class="wishlist-empty__content">
        <span class="wishlist-empty__icon" aria-hidden="true">
          <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24.9222 7.17047L22 9.88539L19.0778 7.16269C11.8687 -0.0796912 1.22405 6.3945 1.00455 13.773C0.718252 23.3841 13.9988 35.4146 22 41C30.0012 35.4146 43.2817 23.3822 42.9954 13.773C42.7759 6.3945 32.1313 -0.0796912 24.9222 7.17047Z" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <h2>${escapeHtml(isError ? text.loadError : text.emptyTitle)}</h2>
        ${isError ? '' : `<p>${escapeHtml(text.emptyBody)}</p>`}
        <div class="wishlist-empty__actions">
          <a class="wishlist-button" href="/collections/new-arrivals">${escapeHtml(text.browseNew)}</a>
          <a class="wishlist-button wishlist-button--secondary" href="/collections/sale">${escapeHtml(text.shopSale)}</a>
        </div>
      </div>
    </div>
  `;

  const getWholesalePrice = (variantId, productId) => {
    if (!customerTags) return;
    $.ajax({
      url: `https://iploc.ehobbyasia.com/variant_meta.php?vid=${encodeURIComponent(variantId)}&pid=${encodeURIComponent(productId)}`,
      type: 'POST',
      dataType: 'jsonp',
      success: (response) => {
        const edges = response?.data?.productVariant?.metafields?.edges || [];
        const match = edges.find((edge) => edge?.node?.key === `price_${customerTags}`);
        if (!match) return;
        const price = Number(match.node.value) / 100;
        const wholesale = root.querySelector(`[data-wholesale-price="${CSS.escape(String(variantId))}"]`);
        const retail = root.querySelector(`[data-retail-price="${CSS.escape(String(variantId))}"]`);
        if (wholesale) wholesale.textContent = `$${price.toFixed(2)}`;
        if (retail) retail.style.textDecoration = 'line-through';
      }
    });
  };

  const productCard = (value) => {
    const productId = String(value.id);
    const variantId = String(value.variant_id);
    const productUrl = `/products/${encodeURIComponent(value.handle)}`;
    const productTitle = escapeHtml(value.title);
    const productImage = escapeHtml(value.image);
    const variantPrice = escapeHtml(value.variant_price);

    return `
      <article class="wishlist-card">
        <a class="wishlist-card__link" href="${productUrl}">
          <div class="wishlist-card__media">
            <img src="${productImage}" alt="${productTitle}" loading="lazy">
          </div>
          <div class="wishlist-card__body">
            <h2 class="wishlist-card__title">${productTitle}</h2>
            <div class="wishlist-card__price" data-retail-price="${escapeHtml(variantId)}">$${variantPrice}</div>
            <div class="wishlist-card__wholesale" data-wholesale-price="${escapeHtml(variantId)}"></div>
          </div>
        </a>
        <div class="wishlist-card__actions">
          <button class="wishlist-card__add addtocartbutton" type="button" data-product-id="${escapeHtml(productId)}" data-variant-id="${escapeHtml(variantId)}">${escapeHtml(text.addToCart)}</button>
          <button class="wishlist-card__remove removewishlistbutton" type="button" data-product-id="${escapeHtml(productId)}" data-variant-id="${escapeHtml(variantId)}">${escapeHtml(text.remove)}</button>
        </div>
      </article>
    `;
  };

  const queryUrl = customerId
    ? `/a/wishlist?type=api&customerid=${encodeURIComponent(customerId)}&version=1`
    : `/a/wishlist?type=api&wishlistid=${encodeURIComponent(getWishlistId())}&version=1`;

  $.ajax({
    url: queryUrl,
    dataType: 'json',
    cache: false,
    success: (data) => {
      const items = Array.isArray(data?.items) ? data.items : [];
      if (!items.length) {
        results.innerHTML = emptyState();
        return;
      }

      results.innerHTML = `<div class="wishlist-grid">${items.map(productCard).join('')}</div>`;
      if (share) share.hidden = false;
      items.forEach((item) => getWholesalePrice(item.variant_id, item.id));
    },
    error: () => {
      results.innerHTML = emptyState(true);
    }
  });

  root.addEventListener('click', async (event) => {
    const addButton = event.target.closest('.addtocartbutton');
    if (addButton) {
      addButton.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: Number(addButton.dataset.variantId),
              quantity: 1
            }]
          })
        });
        if (!response.ok) throw new Error('Cart request failed');
        window.location.assign('/cart');
      } catch (error) {
        addButton.disabled = false;
      }
      return;
    }

    const removeButton = event.target.closest('.removewishlistbutton');
    if (!removeButton || typeof window.RemoveFromSmartWishlist !== 'function') return;
    window.RemoveFromSmartWishlist(removeButton.dataset.productId, removeButton.dataset.variantId);
    window.location.reload();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
